import React from 'react';
import { Link } from 'react-router-dom';
import { InfoIcon } from 'lucide-react';
import { Hero } from '../components/Hero';
import { CatalogRow } from '../components/CatalogRow';
import { PosterFallback } from '../components/PosterFallback';
import { useCatalog } from '../contexts/CatalogContext';
import { brand } from '../data/siteContent';
import { buttonClass, pagePadding } from '../utils/styles';
export function Home() {
  const {
    featured,
    published,
    upcoming,
    hasDemoContent
  } = useCatalog();
  const rows = [{
    id: 'originals',
    title: 'NICOLE ORIGINALS',
    items: published.filter(p => p.isOriginal),
    emptyMessage: 'Las obras originales de Nicole aparecerán aquí al publicarse.'
  }, {
    id: 'peliculas-cortometrajes',
    title: 'Películas y cortometrajes',
    items: published.filter(p => p.category === 'pelicula' || p.category === 'cortometraje'),
    emptyMessage: 'Todavía no hay películas ni cortometrajes publicados.'
  }, {
    id: 'ultimas',
    title: 'Últimas publicaciones',
    items: published.slice(0, 12),
    emptyMessage: 'Aún no hay publicaciones.'
  }, {
    id: 'universo',
    title: 'El universo de Nicole',
    items: published.filter(p => p.collection),
    emptyMessage: 'Las colecciones del universo de Nicole se publicarán aquí.'
  }, {
    id: 'proximos',
    title: 'Próximos estrenos',
    items: upcoming,
    emptyMessage: 'No hay estrenos programados por ahora.'
  }];
  return <>
      {featured ? <Hero production={featured} data-id="element-403" data-mp="2d5dvm76cbvsz" /> : <section aria-labelledby="hero-title" className="relative isolate flex h-[78svh] min-h-[520px] items-end overflow-hidden" data-id="element-404" data-mp="2895lj8702sso">
          <div className="absolute inset-0 -z-10" data-id="element-405" data-mp="23auaiu4yyc8v">
            <PosterFallback variant="hero" data-id="element-406" data-mp="1z7pcb3rx8wq1" />
            <div className="absolute inset-0 bg-gradient-to-r from-night via-night/70 to-night/0" data-id="element-407" data-mp="1z6mk8siv4o8j" />
          </div>
          <div className={`pb-20 md:pb-28 ${pagePadding}`} data-id="element-408" data-mp="1uap5urr5trye">
            <h1 id="hero-title" className="max-w-2xl font-display text-5xl font-black uppercase leading-[0.95] tracking-tight md:text-7xl" data-id="element-409" data-mp="1kjxpt53gx190">
              {brand.name}
            </h1>
            <p className="mt-5 max-w-xl text-lg text-mist" data-id="element-410" data-mp="1ankwi8bu4pes">{brand.slogan}. El primer estreno llegará muy pronto.</p>
            <Link to="/sobre-nicole" className={buttonClass('secondary', 'lg', 'mt-8')} data-id="element-411" data-mp="1fmfe56y2g7xb">
              Sobre Nicole
            </Link>
          </div>
        </section>}

      <div className="relative z-10 -mt-8 space-y-8 pb-20 md:-mt-14 md:space-y-10" data-id="element-412" data-mp="28aky3rhapsw3">
        {hasDemoContent && <div className={pagePadding} data-id="element-413" data-mp="1tkm3fyoy8zld">
            <p className="flex items-start gap-2.5 text-xs leading-relaxed text-mist md:items-center" data-id="element-414" data-mp="1tjkqtpsac51j">
              <InfoIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 md:mt-0" data-id="element-415" data-mp="1yi5hoylndcdb" />
              Las obras marcadas como DEMO son ejemplos visuales de la plataforma y no forman parte de la obra de Nicole.
            </p>
          </div>}
        {rows.map(row => <CatalogRow key={row.id} id={row.id} title={row.title} productions={row.items} emptyMessage={row.emptyMessage} data-id="element-416" data-mp="fjzdfeu9zu8z" />)}
      </div>
    </>;
}